import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/career.css';
import { sendMail } from '../careerApi';
import Spinner from './components/spinner.js';


export const ContactUs = () => {
  const maxSteps = 10; // Limit the number of steps
  const [currentStep, setCurrentStep] = useState(0);
  const [inputValues, setInputValues] = useState(Array(maxSteps).fill(''));
  const [mapValues, setMapValues] = useState({});
  const [checkboxValues, setCheckboxValues] = useState([]);
  const [employmentValue, setEmploymentValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const form = useRef(null);
  const navigate = useNavigate();

  const handleNext = () => {
    if (currentStep === 6) {
      setCurrentStep(currentStep + 2);
    }
    else if ((currentStep === 0 || currentStep === 5) || (inputValues[currentStep] && currentStep < maxSteps - 1)) {
      setCurrentStep(currentStep + 1);
    }
    setInputValues([...inputValues]);
  };

  const handleBack = () => {
    if (currentStep === 8) {
      setCurrentStep(currentStep - 2);
    }
    else if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMapValues({
      ...mapValues,
      [name]: value,
    });
    const newValues = [...inputValues];
    newValues[currentStep] = value;
    setInputValues(newValues);
  };

  const handleCheckboxChange = (e) => {
    const { name, checked, id } = e.target;
    let updatedCheckboxValues = [];

    if (checked) {
      updatedCheckboxValues.push(name);
      setMapValues({
        ...mapValues,
        [id]: name,
      });
    }

    setCheckboxValues(updatedCheckboxValues);
    const newValues = [...inputValues];
    newValues[currentStep] = updatedCheckboxValues.join(', ');
    setInputValues(newValues);
  };

  const handleEmploymentChange = (e) => {
    const { name, checked, id } = e.target;
    let updatedEmploymentValues = [];

    if (checked) {
      updatedEmploymentValues.push(name);
      setMapValues({
        ...mapValues,
        [id]: name,
      });
    }

    setEmploymentValue(updatedEmploymentValues);
    const newValues = [...inputValues];
    newValues[currentStep] = updatedEmploymentValues.join(', ');
    setInputValues(newValues);
  };

  const isNextDisabled = () => {
    if (currentStep === maxSteps - 1) return true;
    if (currentStep === 0 || currentStep === 5) return false;
    if (currentStep === 6) return !inputValues[currentStep] || !inputValues[currentStep + 1];
    return !inputValues[currentStep];
  };

  const isSendDisabled = () => {
    return !inputValues[currentStep];
  };

  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await sendMail(mapValues); // Wait for the sendMail response
      if (response.status === 200) {
        navigate('/nukreipimas');
      } else {
        // Handle non-successful responses
        console.error('Failed to send email:', response);
        alert('Nepavyko išsiųsti. Bandykite dar kartą.');
      }
    } catch (error) {
      // Handle errors
      console.error('Error sending email:', error);
      alert('Įvyko klaida. Bandykite dar kartą.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="careerHeader">
        <h1 className="careerInfoHeader">Registruokis Karjeros Pokalbiui</h1>
      </div>
      <p className='careerP'>Turime bene moderniausią mokymų sistemą Lietuvoje, kuri duoda apčiuopiamus rezultatus, o ne pažadus. Mes
        tikime, kad edukacija yra didžiausia jėga keičianti pasaulį, todėl per mokymus, konsultacijas ir tobulėjimą
        padedame susikurti finansinę gerovę ir laisvę.</p>
      <p className='careerP'>
        Gali dirbti iš kur nori, kiek nori ir kada nori. Mūsų mokymų sistema prieinama online 24/7. Pats pasirenki, kiek
        dirbti ir užsidirbti. Gali dirbti kaip papildomą darbą, gali pasinerti pilnu etatu ir imtis vadovo darbų arba plėsti
        patį franšizinį verslo modelį. Registruokitės jau dabar, apačioje!
      </p>
      <div className="consultText">
        <form ref={form} onSubmit={sendEmail} className="careerParent">
          <div>
            <div style={{ display: currentStep === 0 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Domina papildomos pajamos, karjeros galimybė?</h1>
              <p className='careerP'>
                Ar esi pagalvojęs/us apie darbą finansų srityje? Norėtum ne tik pats/i išmokti geriau
                valdyti asmeninius finansus, užsidirbti, bei turėti galimybę padėti kitiems? Jeigu
                atsakymas TAIP, pildyk formą ir su tavimi bus susisiekta.
              </p>
            </div>
            <div style={{ display: currentStep === 1 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">leškai papildomo ar nuolatinio darbo?</h1>
              <div className='lookingFor'>
                <label className='careerLabel workType'>
                  <input
                    type="checkbox"
                    id="papildomo_darbo"
                    value="Papildomo darbo"
                    name="papildomo_darbo"
                    checked={checkboxValues.includes('papildomo_darbo')}
                    onChange={handleCheckboxChange}
                  />
                  Papildomo darbo
                </label>
                <label className='careerLabel workType'>
                  <input
                    type="checkbox"
                    id="papildomo_darbo"
                    value="Nulatinio darbo"
                    name="nuolatinio_darbo"
                    checked={checkboxValues.includes('nuolatinio_darbo')}
                    onChange={handleCheckboxChange}
                  />
                  Nuolatinio darbo
                </label>
              </div>
            </div>
            <div style={{ display: currentStep === 2 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Šiuo metu: </h1>
              <div>
                <label className='careerLabel'>
                  <input
                    type="checkbox"
                    id="Dirbu"
                    value="Dirbu"
                    name="Dirbu"
                    checked={employmentValue.includes('Dirbu')}
                    onChange={handleEmploymentChange}
                  />
                  Dirbu
                </label>
                <label className='careerLabel'>
                  <input
                    type="checkbox"
                    id="Dirbu"
                    value="Nedirbu"
                    name="Nedirbu"
                    checked={employmentValue.includes('Nedirbu')}
                    onChange={handleEmploymentChange}
                  />
                  Nedirbu
                </label>
              </div>
            </div>
            <div style={{ display: currentStep === 3 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Kodėl norėtum dirbti finansų srityje?</h1>
              <textarea
                name="motivation"
                placeholder="Jūsų atsakymas"
                value={inputValues[3]}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ display: currentStep === 4 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Kokį atlygį norėtum užsidirbti vidutiniškai per mėnesį?</h1>
              <textarea
                name="pay"
                placeholder="Jūsų atsakymas"
                type="text"
                value={inputValues[4]}
                onChange={handleInputChange}
              />
            </div>
            <div style={{ display: currentStep === 5 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Papildomi klausimai?</h1>
              <textarea
                name="questions"
                placeholder="Jūsų klausimai"
                type="text"
                value={inputValues[5]}
                onChange={handleInputChange}
              >
                Default Value
              </textarea>
            </div>
            <div style={{ display: currentStep === 6 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Koks jūsų vardas?</h1>
              <label htmlFor="first_name">Vardas</label>
              <input
                className='careerInputField'
                type="text"
                name="first_name"
                value={inputValues[6]}
                onChange={handleInputChange}

              />
              <label htmlFor="last_name">Pavardė</label>
              <input
                className='careerInputField'
                type="text"
                name="last_name"
                value={inputValues[6 + 1]}
                onChange={(e) => {
                  const { name, value } = e.target;
                  setMapValues({
                    ...mapValues,
                    [name]: value,
                  });
                  const newValues = [...inputValues];
                  newValues[currentStep + 1] = value;
                  setInputValues(newValues);
                }}

              />
            </div>
            <div style={{ display: currentStep === 8 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Telefono numeris</h1>
              <input
                className='careerInputField'
                name="phone_number"
                type="tel"
                value={inputValues[8]}
                placeholder='+370'
                onChange={handleInputChange}
              >
              </input>
            </div>
            <div style={{ display: currentStep === 9 ? '' : 'none' }}>
              <h1 className="careerInfoHeader">Elektroninis paštas*</h1>
              <input className='careerInputField' type="email" name="email_adress" value={inputValues[9]}
                onChange={handleInputChange} />
            </div>
          </div>
          <div>
            {currentStep < maxSteps - 1 && (
              <button className='careerBtn' type="button" onClick={handleNext} disabled={isNextDisabled()}>Pirmyn</button>
            )}
            {currentStep === maxSteps - 1 && (
              <button className='careerBtn' type="submit" disabled={isSendDisabled()}>Send</button>
            )}
            {currentStep > 0 && (
              <button className='careerBtn' type="button" onClick={handleBack} disabled={currentStep === 0}>Atgal</button>
            )}
          </div>
        </form>
        {loading && (
          <div className="loading">
            <Spinner />
          </div>
        )}
      </div>
    </div>
  );
};
export default function Career() {
  return (
    <div>
      <ContactUs />
    </div>
  )
}